// Site-wide constants that point at hosted assets and APIs.
//
// Static files live in the same S3 bucket + CloudFront distribution that serves
// blog content (E2DMPMH4JDDAWE -> s3://feldman-dev-blogs), under an `assets/`
// prefix so they can never collide with a blog slug.
export const ASSET_CDN_BASE = 'https://d31kxobtrqxwq9.cloudfront.net';

/**
 * The resume PDF.
 *
 * The S3 object is uploaded with `Content-Disposition: attachment`, which is
 * what actually forces a download here. The HTML `download` attribute is
 * ignored on cross-origin URLs, so it cannot be relied on for a CDN link.
 */
export const RESUME_URL = `${ASSET_CDN_BASE}/assets/Leo-Feldman-Resume.pdf`;

/**
 * REST API root. One API Gateway fronts blog metadata, TLDR question
 * answering, and comments, all served by the `feldmanDevApi` Lambda.
 */
export const BLOG_API_BASE = 'https://20jm2iutyj.execute-api.us-east-1.amazonaws.com/default';

/**
 * Google Sign-In OAuth client ID (public, not a secret; the Lambda verifies
 * the resulting ID token against it).
 *
 * Set `REACT_APP_GOOGLE_CLIENT_ID` in `.env.local`. When it's blank, the
 * comments UI degrades to read-only instead of rendering a broken button.
 */
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

/** Hard cap on a TLDR question, mirrored server-side. */
export const MAX_QUESTION_CHARS = 1024;

/** Hard cap on a comment, mirrored server-side. */
export const MAX_COMMENT_CHARS = 2000;
